import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { bindActionCreators } from "redux";

import Button from "../../components/button";
import IconEffect1 from "../../components/icons/effect1";
import IconPorto from "../../components/icons/porto";
import Animation from "./p5";
import { changeSplash } from "../../redux/actions/options";
import { getMe } from "../../redux/selectors/me";

let COLORS = [
    {
        bg: "pink",
        bgCode: "#ff83ff",
        text: "blue",
        textCode: "#4400f0",
    },
    {
        bg: "purple",
        bgCode: "#750080",
        text: "green",
        textCode: "#00ab7b",
    },
    {
        bg: "green",
        bgCode: "#00ab7b",
        text: "blue",
        textCode: "#4400f0",
    },
    {
        bg: "red",
        bgCode: "#ff0000",
        text: "orange",
        textCode: "#ff6200",
    },
    {
        bg: "orange",
        bgCode: "#ff6200",
        text: "blue",
        textCode: "#4400f0",
    },
];

class Splash extends Component {
    constructor(props) {
        super(props);

        this.state = {
            width: window.innerWidth,
            height: window.innerHeight,
            remove: false,
        };

        this.selectedColor = COLORS[Math.floor(Math.random() * COLORS.length)];

        this._calcWindowSize = this._calcWindowSize.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this._calcWindowSize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this._calcWindowSize);
    }

    _calcWindowSize() {
        this.setState({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }

    _renderText() {
        const { locale } = this.props;

        let newLocale = "en";
        if (locale === "en") {
            newLocale = "pt";
        }

        return (
            <div className="z-50 absolute top-0 left-0 right-0 pt-20 px-20 md:pt-40 md:px-50 flex justify-between items-center">
                <p className="uppercase text-30 md:text-50 font-judge font-bold"></p>
                <Button
                    url={"/" + newLocale}
                    height="h-30"
                    borderColor={"border-" + this.selectedColor.text}
                    backgroundColorOver={"bg-" + this.selectedColor.text}
                    textStyle={
                        "font-brown group- hover-hover:group-hover:text-" +
                        this.selectedColor.bg +
                        " text-19 font-bold text-" +
                        this.selectedColor.text
                    }
                    wrapperStyle="px-10"
                    text={newLocale.toUpperCase()}
                />
            </div>
        );
    }

    _renderFooter() {
        return (
            <div className="absolute left-0 bottom-0 right-0 xl:flex justify-between items-center z-10 px-20 pb-20 md:px-50 md:pb-40">
                <p className="text-30 md:text-50 font-judge font-bold mb-8 xl:mb-0">
                    PAULO CUNHA E SILVA
                </p>
                <div className="flex-1 xl:ml-60 font-bold mb-20 xl:mb-0 mt-8">
                    <div className="flex items-baseline mb-4">
                        <p className="text-12 md:text-19 mr-6">
                            Residências Artísticas
                        </p>
                        <IconEffect1
                            className={
                                "w-12 h-12 md:w-16 md:h-16 md:mx-6 pt-4 text-" +
                                this.selectedColor.text
                            }
                        />
                        <p className="text-12 md:text-19 ml-6">
                            Artes Performativas
                        </p>
                    </div>
                    <div className="flex items-baseline">
                        <p className="text-12 md:text-19 mr-6">
                            Artistic Residencies
                        </p>
                        <IconEffect1
                            className={
                                "w-12 h-12 md:w-16 md:h-16 md:mx-6 pt-4 text-" +
                                this.selectedColor.text
                            }
                        />
                        <p className="text-12 md:text-19 ml-6">
                            Performing Arts
                        </p>
                    </div>
                </div>
                <IconPorto className="w-60 h-17 md:w-112 md:h-30" />
            </div>
        );
    }

    _renderVideo() {
        const { width, height } = this.state;

        let bottomHeight = 100;
        if (width < 768) {
            bottomHeight = 133;
        } else if (width < 1280) {
            bottomHeight = 205;
        }
        let wrapperWidth = width * 1.2;
        let wrapperHeight = (height - bottomHeight) * 1.2;
        let marginTop =
            (height - (height - bottomHeight) * 1.2) / 2 - bottomHeight / 2;
        let marginLeft = (width - width * 1.2) / 2;

        return (
            <div
                className="absolute overflow-hidden"
                style={{
                    width: wrapperWidth + "px",
                    height: wrapperHeight + "px",
                    marginTop: marginTop + "px",
                    marginLeft: marginLeft + "px",
                }}
            >
                <Animation
                    width={wrapperWidth}
                    height={wrapperHeight}
                    backgroundColor={this.selectedColor.bgCode}
                    textColor={this.selectedColor.textCode}
                />
            </div>
        );
    }

    render() {
        const { width, height, remove } = this.state;
        const { visible, user } = this.props;

        if (remove) return null;

        return (
            <div
                onClick={() => {
                    this.props.changeSplash(false);
                    setTimeout(() => {
                        this.setState({
                            remove: true,
                        });
                    }, 600);
                }}
                className={
                    "close-cursor transition duration-500 z-50 fixed inset-0 flex justify-between flex-col text-" +
                    this.selectedColor.text +
                    " bg-" +
                    this.selectedColor.bg
                }
                style={{
                    width: width + "px",
                    height: height + "px",
                    opacity: visible ? 1 : 0,
                    pointerEvents: visible ? "auto" : "none",
                }}
            >
                <Helmet>{visible && <body className="modal-open" />}</Helmet>
                {this._renderVideo()}
                {this._renderFooter()}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    user: getMe(state),
    visible: state.app.isSplashVisible,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeSplash,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Splash);
